export default __webpack_public_path__ + "static/media/cardWithShadow.8cc6ac7c.png";